// Lets a tool passed as ReplyPanel's `extraTools` insert text into the reply body.
import { createContext, useContext } from 'react'

/** ready is false until the reply textarea exists; reason says why. */
export type InsertIntoBody = { ready: boolean; reason?: string; insertIntoBody: (text: string) => void }
export const NOT_READY: InsertIntoBody = { ready: false, reason: 'Open a draft first', insertIntoBody: () => {} }
export const NO_ADDRESS: InsertIntoBody = { ...NOT_READY, reason: 'No reply address for this conversation' }
export const InsertContext = createContext<InsertIntoBody>(NOT_READY)

/** Insert text at the reply's cursor, or after a blank line at the end when staff haven't placed one. */
export function useInsertIntoBody(): InsertIntoBody {
  return useContext(InsertContext)
}
